import React from "react";
import { Confirmed, Unconfirmed, CurrentUnconfirmed } from "./_Icon";
import "../Styles/_StatusInformation.css";
import { orderIsCancelled, orderIsFullyRefunded, getItemsThatRequireShipping } from "../Helpers/OderUtils";

const steps = [
    { label: "Ordered", status: "created" },
    { label: "Authorized", status: "authorized" },
    { label: "Processing", status: "processed" },
    { label: "Ship", status: "shipped" },
    { label: "Deliver", status: "delivered" }
];

const isStepCompleted = (currentStepIndex, index, isLastStepCompleted) => currentStepIndex > index || (isLastStepCompleted && index === steps.length - 1);

const getStepClassName = (currentStepIndex, index, isLastStepCompleted) => {
    if (isStepCompleted(currentStepIndex, index, isLastStepCompleted)) {
        return "step completed";
    } else if (currentStepIndex === index) {
        return "step active";
    } else {
        return "step";
    }
};

const getStepIcon = (currentStepIndex, index, isLastStepCompleted) => {
    if (isStepCompleted(currentStepIndex, index, isLastStepCompleted)) {
        return <Confirmed fill="#00999e" />;
    } else if (currentStepIndex === index) {
        return <CurrentUnconfirmed stroke="#00999e" />;
    } else {
        return <Unconfirmed stroke="lightgrey" />;
    }
};

const getAdditionalProgressBarStatus = (currentStepIndex, index, isLastStepCompleted) => {
    if (isStepCompleted(currentStepIndex, index, isLastStepCompleted)) {
        return "completed";
    } else if (currentStepIndex === index) {
        return "active";
    } else {
        return "not-started";
    }
};

const StatusInformation = ({ currentLanguage, order }) => {
    if (orderIsCancelled(order) || orderIsFullyRefunded(order) || getItemsThatRequireShipping(order).length === 0) {
        return false;
    }

    const subOrders = order.sub_orders;

    const latestStatus = subOrders.reduce((latest, subOrder) => {
        const lastCompletedStatus = subOrder.order_statuses.filter(status => status.show && status.date).sort((a, b) => new Date(b.date) - new Date(a.date))[0];

        if (lastCompletedStatus && (!latest || new Date(lastCompletedStatus.date) > new Date(latest.date))) {
            return lastCompletedStatus;
        }
        return latest;
    }, null);

    const currentStepIndex = latestStatus ? steps.findIndex(step => step.status === latestStatus.status.toLowerCase()) + 1 : 0;
    const isLastStepCompleted = currentStepIndex >= steps.length;

    const statuses = currentLanguage.ORDER_PAGE.STATUS_BAR_SECTION.STATUSES;

    return (
        <div className="order-progress allow-focus" tabIndex="0">
            {steps.map((step, index) => {
                const isVisible =
                    index === currentStepIndex ||
                    index === currentStepIndex + 1 ||
                    (currentStepIndex === steps.length - 1 && index === currentStepIndex - 1) ||
                    (isLastStepCompleted && index === steps.length - 1);

                const statusKey = step.status.toUpperCase();
                const statusText = currentStepIndex === index ? statuses[statusKey].ACTIVE : statuses[statusKey].COMPLETED;

                return (
                    <div key={index} className={`${getStepClassName(currentStepIndex, index, isLastStepCompleted)} ${isVisible ? "visible" : "hidden"}`}>
                        {getStepIcon(currentStepIndex, index, isLastStepCompleted)}
                        <div className="label">{statusText}</div>
                        <div className="progress-bar-background">
                            <div className={`progress-bar ${getAdditionalProgressBarStatus(currentStepIndex, index, isLastStepCompleted)}`}>
                                {(currentStepIndex === index || (isLastStepCompleted && index === steps.length - 1)) && <div className="progress-circle"></div>}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StatusInformation;
